import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=2fc646ea&scoped=true&"
import script from "./ImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=2fc646ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc646ea",
  null
  
)

export default component.exports